import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function TopRatedProducts() {

    const api = "https://mkbackend-production.up.railway.app";

    const navigate = useNavigate();

    const [products, setProducts] = useState([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    const fetchProducts = async (pageNo) => {

        try {

            setLoading(true);

            const res = await axios.get(
                `${api}/top-rated?page=${pageNo}`
            );

            if (pageNo === 1) {

                setProducts(res.data);

            } else {

                setProducts((prev) => [
                    ...prev,
                    ...res.data
                ]);

            }

            if (res.data.length < 10) {
                setHasMore(false);
            }

        } catch (err) {

            console.log(err);

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        fetchProducts(1);

    }, []);

    const handleShowMore = () => {

        const nextPage = page + 1;

        setPage(nextPage);

        fetchProducts(nextPage);

    };

    return (
        <div className="top-rated-products">

            <div className="product">

                {products.map((item) => {

                    // Slug based URL
                    const shopSlug =
                        item.owner?.slug || item.shopSlug;

                    const productSlug =
                        item.slug;

                    return (
                        <div
                            key={item._id}
                            className="product-card"
                            onClick={() =>
                                navigate(
                                    `/product/${shopSlug}/${productSlug}`
                                )
                            }
                        >

                            <img
                                src={item.image}
                                alt={item.name}
                            />

                            <h3>{item.name}</h3>

                            <p>Rs: {item.price}</p>

                            <div className="product-rating-display">

                                <span>
                                    ⭐{" "}
                                    {item.averageRating?.toFixed(1) ||
                                        "0.0"}
                                </span>

                                <span>
                                    ({item.totalReviews || 0} Reviews)
                                </span>

                            </div>

                        </div>
                    );

                })}

            </div>

            {hasMore && (

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "20px"
                    }}
                >

                    <button
                        onClick={handleShowMore}
                        disabled={loading}
                    >

                        {loading
                            ? "Loading..."
                            : "Show More Products"}

                    </button>

                </div>

            )}

        </div>
    );
}